import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Input, UncontrolledTooltip } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import { PaginationTotal } from '../../../../../commons/controls';
import CikkSelect from '../CikkSelect.jsx';
import _ from 'lodash';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { DatetimePicker, DatePicker } from '../../../../../commons/controls.js';
import { ProgressButton } from '../../../../../commons/ProgressButton';
import Service from '../services.js';
import moment from 'moment';
import Lib from '../../../../../commons/lib';
import NumberFormatter from '../../../../../commons/NumberFormatter';
import RFForm from '../../../../../components/Form/RFForm';
import RFField from '../../../../../components/Form/RFField';
import CustomTooltip from '../../../../../components/Tooltip/CustomTooltip';
import getTooltip from './BevetelezesTooltip';
import getTooltipKeszlet from '../../../KeszletTooltips';
import SelectField from '../../../../../components/Form/SelectField';
import TimeFormatter from '../../../../../commons/TimeFormatter';


const STYLE_ROW = {marginTop: '15px'};
class BevetelezesForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasRendelesModule: false,

      modalTorles: false,
      modalCikk: false,
      modalAccept: false,
      modalPartnerFelvitel: false,
      modalRendelesCikk: false,
      mentesLoadingButton: false,
      szallitoError: false,

      rendelesCikkSelected: [],

      formCikkVisszList: [],
      formRaktar: null,
      formPenznem: null,
      formFizmod: null,
      formPartner: null,
      // checkForRendelesModule()-ból kivenni az alapérték állítást, ha más értéket is felvehet a mező/nem szükséges a default
      formFunkcioNev: null,
      formFunkcio: null,
      formSzallitolevelszam: '',
      formSzamlaszam: '',
      formFizetesihatarido: null,
      formMozgasDatum: new Date(), 

      telepulesMezo: [],
      editobj: {},
      bevetel: {},
      cikkek: [],
      penznem: {},
      
      searchButtonLoading: false,
      addButtonLoading: false,
      modifyButtonLoading: false,
      deleteButtonLoading: false,
      sendButtonLoading: false,
      saveButtonLoading: false,
    };
    this.raktarAzonosito = 'BEVETEL';
    this.refCikkSelect = React.createRef();
  }

  componentDidMount(){
    this.selected = false;
  }

  componentWillMount(){
    this.checkForRendelesModule();
    let params = new URL(window.location.href).searchParams;
    let id = params.get('id');
    if (this.props.modositas === 'true') {
      if (id){
        this.getData(id);
      } 
    }else{
      Service.listAktivPenznem((err, res) => {
        if (!err) {
          let defaultPenznem = [];
          res[0].filter(x => x.defaultcurrency).forEach((item) => {
            defaultPenznem = item;
          });
          this.setState({
            formPenznem: defaultPenznem,
            bevetel: {}
          });
        }
      });
    }
  }

  modosit = () => {
    this.props.globals.route.navigate(this.props.globals.public_url.concat('/admin/keszlet/keszletkezeles/bevetelezes/felvetel'));
  }

  handleBackClick = () => {
    this.props.globals.route.navigate(this.props.globals.public_url.concat('/admin/keszlet/keszletkezeles?page=1'));
  }
  
  toggle = () => {
    this.setState({ modal: !this.state.modal });
  }

  toggleTorles = () => {
    this.setState({ modalTorles: !this.state.modalTorles });
  }

  toggleAccept = () => {
    this.setState({ modalAccept: !this.state.modalAccept });
  }

  toggleCikk = () => {
    this.setState({ modalCikk: !this.state.modalCikk });
  }

  togglePartnerFelvitel = () => {
    this.setState({ modalPartnerFelvitel: !this.state.modalPartnerFelvitel, telepulesMezoInaktiv: true });
  }

  toggleRendelesCikk = () => {
    this.setState({ modalRendelesCikk: !this.state.modalRendelesCikk, rendelesCikkSelected: [] });
  }

  getData = (id) => {
    Service.getBevetelezes(id, (err, res) => {
      if (!err) {
        let bevetel = {...res[0][0]};
        this.setState({
          bevetel: bevetel,
          cikkek: bevetel.cikkek,
          formPartner: bevetel.partner,
          formPenznem: bevetel.penznem,
          formRaktar: bevetel.raktar,
          formFizmod: bevetel.fizmod,
          formMozgasTipus: bevetel.mozgasTipus,
          formSzallitolevelszam: bevetel.szallitolevelszam,
          formSzamlaszam: bevetel.szamlaszam,
          formFizetesihatarido: bevetel.fizetesihatarido,
          formMozgasDatum: bevetel.mozgasDatum,
        }, () => {
          if (this.state.hasRendelesModule && bevetel.partner) {
            Service.listRendelesBevetelezes(bevetel.partner.id, bevetel.funkcioId, (err2, res2) => {
              if (!err2) {
                this.setState({ funkcioOptions: res2[0], formFunkcio: res2[0].find(r => r.id == bevetel.funkcioId) });
              }
            });
          }
          if (this.isVisszaruMozgTipus() && bevetel.elozmenyid) {
            Service.getCsokkenes(bevetel.elozmenyid, (err, res) => {
              if (!err) {
                this.handleVisszaruChange({...res[0][0]}, true);
              }
            });
          }
        });
      }
    });
  }

  checkForRendelesModule = () => {
    Service.checkForRendelesModule((err, res) => {
      if (!err) {
        this.setState({ hasRendelesModule: res[0] == true });
        if (res[0]) {
          this.setState({ formFunkcioNev: 'SZALLITOI_RENDELES' });
        }
      }
    });
  }

  handleRendelesCikkSubmit = () => {
    const { formFunkcio, rendelesCikkSelected } = this.state;
    const rendelescikkek = formFunkcio.rendelescikkbeans.filter(rc => rendelesCikkSelected.includes(rc.id));
    let cikkekNew = [];
    rendelescikkek.forEach((rc) => {
      cikkekNew.push({
        cikk: rc.cikk,
        mennyiseg: rc.mennyiseg,
        cikkid: rc.cikk.id,
        funkciotetelId: rc.id,
        funkciotetel: 'SZALLITOI_RENDELES_CIKK',
        egysegarnetto: rc.nettoEgysegar,
        egysegarbrutto: rc.bruttoEgysegar,
        beszerzesnetto: rc.nettoBeszerzesiar,
        beszerzesbrutto: rc.bruttoBeszerzesiar,
      });
    });
    let { cikkek } = this.state;
    cikkek.push(...cikkekNew);
    this.setState({ cikkek, rendelesCikkSelected: [], modalRendelesCikk: false });
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  save = (event, bevetelObj) => {
    let submitType = document.activeElement.getAttribute('id');
    const { cikkek } = this.state;

    if (cikkek && cikkek.length === 0 && submitType !== 'save-and-close') {
      this.props.globals.addWarning('Cikk kiválasztása kötelező!');
      return;
    }

    let submitObj = {};
    submitObj.partnerid = this.state.formPartner && this.state.formPartner.id;
    submitObj.penznemid = this.state.formPenznem && this.state.formPenznem.id;
    submitObj.raktarid = this.state.formRaktar && this.state.formRaktar.id;
    submitObj.fizmodId = this.state.formFizmod && this.state.formFizmod.id;
    submitObj.mozgasDatum = this.state.formMozgasDatum && TimeFormatter.formatIso(this.state.formMozgasDatum);
    submitObj.mozgasTipus = this.state.formMozgasTipus && this.state.formMozgasTipus.id;
    submitObj.szallitolevelszam = this.state.formSzallitolevelszam;
    submitObj.szamlaszam = this.state.formSzamlaszam;
    submitObj.fizetesihatarido = this.state.formFizetesihatarido && TimeFormatter.formatDate(this.state.formFizetesihatarido);
    if (this.isVisszaruMozgTipus())
      submitObj.elozmenyid = this.state.formElozmenyKeszlet?.id;
    if (this.state.hasRendelesModule && this.state.formFunkcio) {
      submitObj.funkcio = this.state.formFunkcioNev;
      submitObj.funkcioId = this.state.formFunkcio && this.state.formFunkcio.id;
    }
    this.setState({ szallitoError: !this.state.formPartner });

    if (submitType === 'save-and-close' && !this.state.modalAccept) {
      this._currentAcceptObj = bevetelObj;
      this.toggleAccept();
      return;
    } if (submitType === 'save-and-close' && this.state.modalAccept) {
      this.toggleAccept();
    }

    if (this.state.bevetel && this.state.bevetel.id) {
      this.editKeszlet(submitObj); 
    } else {
      this.addKeszlet(submitObj); 
    }
  }

  addKeszlet(bevetelObj) {
    let submitType = document.activeElement.getAttribute('id');
    bevetelObj.cikkek = this.state.cikkek.map((c) => { return { ...c, funkciotetel: typeof c.funkciotetel === 'string' ? c.funkciotetel : c.funkciotetel && c.funkciotetel.name, cikkVisszaru: null, selejtezesOka: this.emptyOrNull(c.selejtezesOka) }; });

    if (submitType === 'save-and-close') {
      this.setState({ mentesLoadingButton: true }, () => {
        Service.acceptAddBevetelezes(bevetelObj, (err, res) => {
          if (!err) {
            this.props.globals.addSuccess('Készletnövekedés tétel véglegesítve!');
            this.props.globals.route.navigate(this.props.globals.public_url.concat('/admin/keszlet/keszletkezeles?page=1'));  
          }
          this.setState({ mentesLoadingButton: false });
        });
      });
    } else {
      this.setState({ mentesLoadingButton: true }, () => {
        Service.addBevetelezes(bevetelObj, (err, res) => {
          if (!err) {
            this.props.globals.addSuccess('Készletnövekedés tétel hozzáadva!');
            this.props.globals.route.navigate(this.props.globals.public_url.concat('/admin/keszlet/keszletkezeles?page=1'));  
          }
            this.setState({ mentesLoadingButton: false });
        });
      });
    }
  }

  editKeszlet(bevetelObj) {
    let submitType = document.activeElement.getAttribute('id');
    bevetelObj.cikkek = this.state.cikkek.map((c) => { return { ...c, funkciotetel: typeof c.funkciotetel === 'string' ? c.funkciotetel : c.funkciotetel && c.funkciotetel.name, cikkVisszaru: null, selejtezesOka: this.emptyOrNull(c.selejtezesOka) }; });

    if (submitType === 'save-and-close') {
      this.setState({ mentesLoadingButton: true }, () => {
        Service.acceptEditBevetelezes(bevetelObj, this.state.bevetel.id, (err, res) => {
          if (!err) {
            this.props.globals.addSuccess('Készletnövekedés tétel módosítva és véglegesítve!');
            this.props.globals.route.navigate(this.props.globals.public_url.concat('/admin/keszlet/keszletkezeles?page=1'));  
          }
          this.setState({ mentesLoadingButton: false });
        });
      });
    } else {
      this.setState({ mentesLoadingButton: true }, () => {
        Service.editBevetelezes(bevetelObj, this.state.bevetel.id, (err, res) => {
          if (!err) {
            this.props.globals.addSuccess('Készletnövekedés tétel módosítva!');
            this.props.globals.route.navigate(this.props.globals.public_url.concat('/admin/keszlet/keszletkezeles?page=1'));  
          }
          this.setState({ mentesLoadingButton: false });
        });
      });
    }
  }

  loadFizmodOptions = (input, callback) => {
    Service.listAktivFizetesimod((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter(k => k.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }


  loadRaktarOptions = (input, callback) => {
    Service.listBizonylatRaktar(this.raktarAzonosito, null, null, (err, res) => {
      if (!err) {
        let options = [];
        res[0].filter(k => k.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);

        if(!this.isVisszaruMozgTipus() && !input && !this.state.formRaktar && options.length > 0) {
          this.setState({ formRaktar: options[0] });
        }
      }
    });
  }

  loadPenznemOptions = (input, callback) => {
    Service.listAktivPenznem((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter(k => k.defaultcurrency && k.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  loadMozgasTipusOptions = (input, callback) => {
    Service.listMozgastipusBevetelezes((err, res) => {
      if (!err) {
        let options = [];
        res[0]
          .filter(m => m.name.toLowerCase().includes(input.toLowerCase()))
          .filter(m => !m.id.includes('LELTAR'))
          .forEach((item) => {
            options.push(item);
          });
        callback(options);
      }
    });
  }

  loadVisszaruCsokkenes = (input, callback) => {
    if (input) {
      let filter = {
        bizonylatszam: input,
        mozgasTipusList: ['FELH', 'ERTE'],
        allapot: 'NORMAL'
      };
      Service.listCsokkenes(filter, (err, res) => {
        if (!err) {
          callback(res[0]);
        }
      });
    }
  }

  iconCikkFormatter = (cell, row) => {
    return (
      <div>
        <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditCikkClick(cell, row)} />
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={0}>Módosítás</UncontrolledTooltip>
        <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleDeleteCikkClick(row)} />
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'torles'} delay={0}>Törles</UncontrolledTooltip>
      </div>
    );
  }

  handleNewCikkClick = () => {
    this.setState({ editmode: false, editobj: undefined }, () => {
      this.toggleCikk();
    });
  }

  handleEditCikkClick = (id, cikkobj) => {
    this.setState({ editmode: true, editobj: cikkobj }, () => {
      this.toggleCikk();
    });
  }

  handleDeleteCikkClick = (cikkobj) => {
    this._currentDeleteObj = cikkobj;
    this.toggleTorles();
  }

  loadPartnerOptions = (text, callback) => {
    let newArray = [];
    if (text && text.length === 0) {
      callback(newArray);
      return;
    } 
    Service.queryPartner('KESZLET_SZALLITO_FORM', text, (err, res) => {
      if (!err) {
        res[0].forEach((item) => {
          newArray.push(item);
        });
        callback(newArray);
      }
    });
  }

  handlePartnerChange = (v) => {
    this.setState({ formPartner: v, formFunkcio: null });
    if (v && this.state.hasRendelesModule) {
      Service.listRendelesBevetelezes(v.id, null, (err, res) => {
        if (!err) {
          this.setState({ funkcioOptions: res[0] });
        }
      });
    } else {
      this.setState({ formFunkcio: null });
    }
  }

  handleInputChange = (e) => {
    const { target } = e;
    const { name } = target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.setState({
      [name]: value
    });
  }

  addPartner = (event, partnerObj) => {
    partnerObj.tipus = 'MAGANSZEMELY';
    partnerObj.szallitovevo = 'SZALLITO';
    partnerObj.statusz = 'AKTIV';
    partnerObj.szallcimeltero = false;
    this.setState({ addButtonLoading: true });
    Service.addPartner(partnerObj, (err, res) => {
      if (!err) {
        this.props.globals.addSuccess('Partner hozzáadva!');
        let bevetel = Object.assign({}, this.state.bevetel);
        bevetel['partner'] = { value: res[0].id, label: res[0].nev };
        this.setState({ bevetel: bevetel });
        this.togglePartnerFelvitel();
      }
      this.setState({ addButtonLoading: false });
    });
  }

  /**
  * Irányítószám input mező kezelése.
  * @param {SytheticEvent} event
  */
  handleIrszamChange = (event, irszam) => {
    this.setState({ telepulesMezoInaktiv: true });
    if (irszam.length >= 2) {
      Service.getTelepulesByIrszam(irszam, (err, res) => {
        if (!err) {
          if (res[0].length > 0) {
            this.setState({ telepulesMezoInaktiv: false, telepulesMezo: res[0], });
          } else {
            this.setState({ telepulesMezo: [], });
          }
        }
      });
    } else {
      this.setState({ telepulesMezo: [] });
    }
  }

  addRendelesFunkcioTetelId = (cikkObj) => {
    if (this.state.hasRendelesModule && this.state.formFunkcio) {
      let array = [...this.state.formFunkcio.rendelescikkbeans];
      array.sort((a, b) => {
        if (a.hatarido < b.hatarido) return -1;
        if (b.hatarido < a.hatarido) return 1;
        return 0;
      });
      let obj = array.find(rc => rc.cikkid == cikkObj.cikkid);
      cikkObj.funkciotetelId = obj ? obj.id : null;
      cikkObj.funkciotetel = 'SZALLITOI_RENDELES_CIKK';
    }
  }

  addCikk = (event, cikkObj) => {
    this.addRendelesFunkcioTetelId(cikkObj);
    this.setState({ cikkek: [...this.state.cikkek, cikkObj], editobj: cikkObj }, () => this.toggleCikk());
  }

  editCikk = (event, cikkObj) => {
    // Funkciotétel átmásolása, ha nem változott a cikk, mert egyébként elveszne, mivel a Form nem tartalmazza a mezőt
    if (this.state.editobj && this.state.editobj.cikkid == cikkObj.cikkid) {
      cikkObj.funkciotetelId = this.state.editobj.funkciotetelId;
      cikkObj.funkciotetel = this.state.editobj.funkciotetel;
    } else {
      this.addRendelesFunkcioTetelId(cikkObj);
    }
    this.state.cikkek[this.state.cikkek.indexOf(this.state.editobj)] = cikkObj;
    this.setState({ cikkek: this.state.cikkek, editmode: false, editobj: cikkObj }, () => this.toggleCikk());
  }

  deleteCikk = (cikkobj) => {
    this.setState({ deleteButtonLoading: true});
    this.setState({ cikkek: this.state.cikkek.filter(cikk => cikk !== cikkobj) }, () => this.toggleTorles());
    this.setState({ deleteButtonLoading: false});
  }

  handleDateInputChange = (e, v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }

  handleVisszaruChange = (v, edit) => {
    this.setState({ formElozmenyKeszlet: v, formCikkVisszList: [] });
    if (!edit)
      this.setState({ cikkek: [] });
    if (v) {
      this.setState({ formRaktar: v.raktar });
      Service.listKeszletCikkVisszaru(v.id, this.state.bevetel?.id, true, (err, res) => {
        if (!err) {
          this.setState({ formCikkVisszList: res[0] });
          let cikkek = [...this.state.cikkek];
          cikkek.forEach(cikk => {
            if (!cikk.visszaru)
              cikk.cikkVisszaru = res[0].find(cikkVissz => cikkVissz.id == cikk.cikkVisszaru.id);
          });
          this.setState({ cikkek });
        }
      });
    }
  }

  handleDateChange = (e,v,type) => {
    if(this.selected) {
      this.selected = false;
      
      switch (type) {
        case 'FORMMOZGAS':
          this.setState({ formMozgasDatum: (moment(e).startOf('day')) });
          break;
        default:
          break;
      }
    } else {
      switch (type) {
        case 'FORMMOZGAS':
          if (!e)
            e = new Date();
          this.setState({ formMozgasDatum: e });
          break;
        default:
          break;
      }
    }
  }

  clearCikks = () => {
    this.setState({ cikkek: [] });
  }

  mozgasTipusRequired = (mozgasTipus) => {
    return this.state.formMozgasTipus && this.state.formMozgasTipus.id === mozgasTipus;
  }

  loadTelepulesOptions = () => {
    return this.state.telepulesMezo.map(e => <option key={e.telepulesid} value={e.telepulesid}>{e.telepulesnev}</option>);
  }

  isFullForm = () => {
    return this.state.bevetel && this.state.formMozgasTipus && this.state.formMozgasTipus.name.includes('Bevételezés'); 
  }

  isVisszaruMozgTipus = () => {
    return this.state.formMozgasTipus && this.state.formMozgasTipus.id == 'VISS';
  }
  
  renderPartnerInputFields = () => {
    let titleStyle = {
      marginBottom: 20,
      marginTop: 10
    };
    return (
      <div className="row">
        <div className="col-md-12">
          <div><h5 style={titleStyle}>Alapadatok:</h5></div>
        </div>
        <div className="col-md-4">
          <RFField
            label="Titulus: "
            name="titulus"
          />
        </div>
        <div className="col-md-4">
          <RFField
            label="Vezetéknév: *"
            name="vezeteknev"
            required
          />
        </div>
        <div className="col-md-4">
          <RFField
            label="Keresztnév: *"
            name="keresztnev"
            required
          />
        </div>
        <div className="col-md-12">
          <div><h5 style={titleStyle}>Elérhetőségek:</h5></div>
        </div>
        <div className="col-md-4">
          <RFField
            label="Ország: *"
            name="orszag"
            value="Magyarország"
            type="text"
            maxLength="50"
            disabled
            required
          />
        </div>
        <div className="col-md-4">
          <RFField
            label="Irányítószám: *"
            name="iranyitoszam"
            onChange={this.handleIrszamChange}
            minLength="2"
            maxLength="20"
            required
          />
        </div>
        <div className="col-md-4">
          <RFField
            type="select"
            name="telepulesid"
            label="Település: *"
            disabled={this.state.telepulesMezoInaktiv}
            required
            defaultSelect={<option value="" disabled >Válassz települést...</option>}
            selectOptions={this.loadTelepulesOptions()}
          />
        </div>
        <div className="col-md-3">
          <RFField
            label="Közterület neve: *"
            name="kozterulet"
            required
          />
        </div>
        <div className="col-md-3">
          <RFField
            label="Közterület jellege: *"
            name="kozteruletjelleg"
            required
          />
        </div>
        <div className="col-md-3">
          <RFField
            label="Házszám: *"
            name="hazszam"
            required
          />
        </div>
        <div className="col-md-3">
          <RFField
            label="Telefon: *"
            name="telefon"
            required
          />
        </div>
      </div>
    );
  }

  renderForm = () => {
    return (
    <div style={{ marginBottom: '15px' }}>
      <div className="row" style={STYLE_ROW}>
        <div className="col-md-4">
          <SelectField
            label='Raktár:'
            variant='async'
            name="formRaktar"
            id="formRaktar"
            placeholder="Kezdj el gépelni..."
            noOptionsMessage={() => 'Nincs keresési eredmény'}
            onChange={v => this.setState({ formRaktar: v })}
            loadOptions={_.debounce(this.loadRaktarOptions, 1000)}
            getOptionLabel={option => option.nev}
            getOptionValue={option => option.id}
            value={this.state.formRaktar}
            defaultOptions
            isClearable
            isDisabled={this.isVisszaruMozgTipus()}
          />
        </div>
        <div className="col-md-4">
          <DatetimePicker
            label={"Mozgás dátuma:"}
            tooltip={<CustomTooltip text={getTooltip('mozgasdatum')} id='mozgasdatumTT' />}
            name="formMozgasDatum"
            formatDate={'YYYY-MM-DD HH:mm:ss'}
            value={this.state.formMozgasDatum && new Date(this.state.formMozgasDatum)}
            // onChange={(e, v) => {this.handleDateInputChange(e, v, 'formMozgasDatum'); this.clearCikks(); this.refCikkSelect.current.clearValues();}}
            onChange={(e,v) => {this.handleDateChange(e,v,'FORMMOZGAS'); this.clearCikks(); this.refCikkSelect.current.clearValues();}} 
            onSelect={(e,v) => { this.selected = true }}
            max={new Date()}
            timePrecision="seconds"
            required
          />
        </div>
      </div>
      {this.isFullForm()
      && (
      <React.Fragment>
        <div className="row" style={STYLE_ROW}>
        <div className="row align-items-center">
          <div className="col-md-4 form-group">
              <SelectField
                variant='async'
                label='Szállító:'
                name="formPartner"
                id="formPartner"
                placeholder="Kezdj el gépelni..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                onChange={this.handlePartnerChange}
                loadOptions={_.debounce(this.loadPartnerOptions, 1000)}
                getOptionLabel={option => option.nev}
                getOptionValue={option => option.id}
                value={this.state.formPartner}
                defaultOptions
                isClearable
              />
            </div>
            {this.state.hasRendelesModule
                && (
                  <>
                    <div className="col-md-4" style={{ marginTop: 10 }}>
                      <Input
                        type="select"
                        name="formFunkcioNev"
                        value={this.state.formFunkcioNev}
                        onChange={this.handleInputChange}
                        disabled={!this.state.formPartner}
                      >
                        <option value="SZALLITOI_RENDELES">Szállítói rendelés</option>
                      </Input>
                    </div>
                    <div className="col-md-4"  style={{ marginTop: 10 }}>
                      <SelectField
                        name="funkcioId"
                        id="funkcioId"
                        placeholder="Kezdj el gépelni a kereséshez..."
                        noOptionsMessage={() => 'Nincs keresési eredmény'}
                        searchPromptText="Kezdj el gépelni a kereséshez..."
                        loadingMessage={() => 'Keresés...'}
                        onChange={v => this.setState({ formFunkcio: v })}
                        options={this.state.funkcioOptions}
                        value={this.state.formFunkcio}
                        getOptionValue={option => option.id}
                        getOptionLabel={option => option && option.bizonylatBean && option.bizonylatBean.bizonylatszam}
                        isDisabled={!this.state.formPartner || this.state.cikkek.length !== 0}
                        isClearable
                      />
                    </div>
                  </>
                )
              }
          </div>
        </div>
        {this.state.hasRendelesModule
          && (
            <div className="row">
              <div className="col-md-2">
                <Button
                  type="button"
                  color="primary"
                  hidden={!this.state.formFunkcio || this.state.formFunkcioNev !== 'SZALLITOI_RENDELES'}
                  onClick={this.toggleRendelesCikk}
                >
                  Rendelés aktív tételei
                </Button>
              </div>
            </div>
          )
        }
        <div className="row" style={STYLE_ROW}>
          <div className="col-md-8">
            <RFField
              label="Szállítólevél száma:"
              name="formSzallitolevelszam" 
              id="formSzallitolevelszam"
              value={this.state.formSzallitolevelszam} 
              onChange={this.handleInputChange}
            />
          </div>
        </div>
        <div className="row" style={STYLE_ROW}>
          <div className="col-md-8">
            <RFField
              label="Számla száma:"
              name="formSzamlaszam"
              id="formSzamlaszam"
              value={this.state.formSzamlaszam} 
              onChange={this.handleInputChange}
            />
          </div>
        </div>
      </React.Fragment>
      )}
      <div className="row" style={STYLE_ROW}>
        <div className="col-md-4">
          <SelectField
            label='Pénznem:'
            variant='async'
            name="formPenznem"
            id="formPenznem"
            placeholder="Kezdj el gépelni..."
            noOptionsMessage={() => 'Nincs keresési eredmény'}
            onChange={v => this.setState({ formPenznem: v })}
            loadOptions={_.debounce(this.loadPenznemOptions, 1000)}
            getOptionLabel={option => option.nev}
            getOptionValue={option => option.id}
            value={this.state.formPenznem}
            defaultOptions
            isClearable
          />
        </div>
        {this.isVisszaruMozgTipus() && <div className='col-md-4'>
          <RFField
            label='Partner (Visszaküldő):'
            name="formPartnerVissz"
            id="formPartnerVissz"
            value={this.state.formElozmenyKeszlet && this.state.formElozmenyKeszlet.partner && this.state.formElozmenyKeszlet.partner.nev}
            disabled
          />
        </div>}
      {this.isFullForm()
        && (
        <React.Fragment>
          <div className="col-md-4">
            <SelectField
              variant='async'
              label='Fizetési mód:'
              name="formFizmod"
              id="formFizmod"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => this.setState({ formFizmod: v })}
              loadOptions={_.debounce(this.loadFizmodOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.id}
              value={this.state.formFizmod}
              defaultOptions
              isClearable
            />
        </div>
        <div className="col-md-4">
          <DatePicker 
            label="Fizetési határidő dátuma:"
            name="formFizetesihatarido"
            value={this.state.formFizetesihatarido ? new Date(this.state.formFizetesihatarido) : null}
            onChange={(e, v) => this.handleDateInputChange(e, v, 'formFizetesihatarido')}
          />
        </div>
        </React.Fragment>
        )}
        </div>
      </div>
    );
}

renderButtons = () => {
  return (
    <div className="top-15-margin">
      <ProgressButton color="primary" id="save" loading={this.state.mentesLoadingButton}> Mentés </ProgressButton>
      {' '}
      <ProgressButton color="primary" id="save-and-close" loading={this.state.mentesLoadingButton}>Mentés és véglegesítés</ProgressButton>
      {' '}
      <Button type="button" color="secondary" onClick={this.handleBackClick}>Mégsem</Button>
    </div>
  );
}

renderCikkTable = () => {
  const options = {
    sizePerPage: 5,
    showTotal: true,
    paginationTotalRenderer: PaginationTotal,
    sizePerPageList: [
      { text: '5', value: 5 },
      { text: '10', value: 10 },
      { text: '25', value: 25 }
    ],
  };

  const columns = [
    {
      dataField: 'cikk.cikkszam',
      text: 'Cikkszám',
      filter: textFilter({
        delay: 400, // default is 500ms
        placeholder: 'Keresés...',
      }),
      style: {
        whiteSpace: 'pre-line',
        textAlign: 'right' 
      },
      sort: true
    },
    {
      dataField: 'cikk.megnevezes',
      text: 'Megnevezés',
      filter: textFilter({
        delay: 400, // default is 500ms
        placeholder: 'Keresés...',
      }),
      style: {
        whiteSpace: 'pre-line',
        textAlign: 'right' 
      },
      sort: true
    },
    {
      dataField: 'mennyiseg',
      text: 'Mennyiség',
      filter: textFilter({
        delay: 400, // default is 500ms
        placeholder: 'Keresés...',
      }),
      style: NumberFormatter.styleTextAlignWhiteSpace,
      formatter: (cell, row) => NumberFormatter.formatterSpaceOsszeg(cell) + (row && row.cikk ? ' ' + row.cikk.mennyisegiEgyseg : ''),
      sort: true
    },
    {
      dataField: 'cikk.aktualisAfaErtek',
      text: 'ÁFA%',
      filter: textFilter({
        delay: 400, // default is 500ms
        placeholder: 'Keresés...',
      }),
      style: NumberFormatter.styleTextAlignWhiteSpace,
      formatter: NumberFormatter.formatterSpaceOsszeg,
      sort: true
    },
    {
      dataField: 'egysegarnetto',
      text: 'Nettó egységár',
      filter: textFilter({
        delay: 400, // default is 500ms
        placeholder: 'Keresés...',
      }),
      style: NumberFormatter.styleTextAlignWhiteSpace,
      formatter: (cell, row) => NumberFormatter.formatterSpaceOsszeg(cell, row),
      sort: true
    },
    {
      dataField: 'egysegarbrutto',
      text: 'Bruttó egységár',
      filter: textFilter({
        delay: 400, // default is 500ms
        placeholder: 'Keresés...',
      }),
      style: NumberFormatter.styleTextAlignWhiteSpace,
      formatter: (cell, row) => NumberFormatter.formatterSpaceOsszeg(cell, row),
      sort: true
    },
    {
      dataField: 'beszerzesnetto',
      text: 'Nettó beszerzési ár',
      filter: textFilter({
        delay: 400, // default is 500ms
        placeholder: 'Keresés...',
      }),
      style: NumberFormatter.styleTextAlignWhiteSpace,
      formatter: (cell, row) => NumberFormatter.formatterSpaceOsszeg(cell, row),
      sort: true
    },
    {
      dataField: 'beszerzesbrutto',
      text: 'Bruttó beszerzési ár',
      filter: textFilter({
        delay: 400, // default is 500ms
        placeholder: 'Keresés...',
      }),
      style: NumberFormatter.styleTextAlignWhiteSpace,
      formatter: (cell, row) => NumberFormatter.formatterSpaceOsszeg(cell, row),
      sort: true
    },
    {
      dataField: 'cikk.id',
      text: 'Műveletek',
      align: 'center',
      headerStyle: { textAlign: 'center' },
      formatter: this.iconCikkFormatter
    }
  ];
  return (
    <React.Fragment>
      <Button className="table-new-button" type="button" color="success" disabled={this.isVisszaruMozgTipus() && !this.state.formElozmenyKeszlet} onClick={this.handleNewCikkClick}>Cikk kiválasztása</Button>
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.cikkek}
          columns={columns}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    </React.Fragment>
  );
}

renderRendelesCikkTable = () => {
  const handleRowSelect = (row, isSelect) => {
    this.setState((previousState) => {
      let array = previousState.rendelesCikkSelected;
      if (isSelect) {
        array.push(row.id);
      } else {
        array = array.filter(id => id != row.id);
      }
      return { rendelesCikkSelected: array };
    });
  };

  const handleRowSelectAll = (isSelect, rows) => {
    this.setState((previousState) => {
      let array = previousState.rendelesCikkSelected;
      if (isSelect) {
        array = rows.map(rc => rc.id);
      } else {
        array = [];
      }
      return { rendelesCikkSelected: array };
    });
  };

  const options = {
    sizePerPage: 5,
    showTotal: true,
    paginationTotalRenderer: PaginationTotal,
    sizePerPageList: [
      { text: '5', value: 5 },
      { text: '10', value: 10 },
      { text: '25', value: 25 }
    ],
  };

  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    selected: this.state.rendelesCikkSelected,
    onSelect: handleRowSelect,
    onSelectAll: handleRowSelectAll
  };

  const filterCikkek = (list) => {
    if (!list) {
      return [];
    }
    const funkciotetelIdList = this.state.cikkek.map(c => c.funkciotetelId);
    return list.filter(rc => !funkciotetelIdList.includes(rc.id));
  };

  const columns = [
    {
      dataField: 'cikk',
      text: 'Cikk megnevezése (Cikkszám)',
      filter: textFilter({
        delay: 400, // default is 500ms
        placeholder: 'Keresés...',
      }),
      style: {
        whiteSpace: 'pre-line',
        textAlign: 'right'
      },
      sort: true,
      formatter: (cell) => {
        return cell.megnevezes + ' (' + cell.cikkszam + ')';
      }
    },
    {
      dataField: 'mennyiseg',
      text: 'Mennyiség (fennmaradó)',
      filter: textFilter({
        delay: 400, // default is 500ms
        placeholder: 'Keresés...',
      }),
      style: NumberFormatter.styleTextAlignWhiteSpace,
      formatter: (cell, row) => NumberFormatter.formatterSpaceOsszeg(cell) + ' ' + row.cikk.mennyisegiEgyseg,
      sort: true
    },
    {
      dataField: 'nettoEgysegar',
      text: 'Nettó egységár',
      filter: textFilter({
        delay: 400, // default is 500ms
        placeholder: 'Keresés...',
      }),
      style: NumberFormatter.styleTextAlignWhiteSpace,
      formatter: cell => NumberFormatter.formatterSpaceOsszeg(cell),
      sort: true
    },
    {
      dataField: 'hatarido',
      text: 'Szállítási határidő',
      filter: textFilter({
        delay: 400, // default is 500ms
        placeholder: 'Keresés...',
      }),
      filterValue: cell => TimeFormatter.format(cell, 'YYYY. MM. DD'),
      formatter: cell => TimeFormatter.format(cell, 'YYYY. MM. DD'),
      sort: true
    },
    {
      dataField: 'vevoiBizonylatBean.bizonylatszam',
      text: 'Vevői rendelés bizonylatszám',
      filter: textFilter({
        delay: 400, // default is 500ms
        placeholder: 'Keresés...',
      }),
      sort: true
    }
  ];
  return (
    <BootstrapTable
      bootstrap4
      keyField="id"
      data={filterCikkek(this.state.formFunkcio && this.state.formFunkcio.rendelescikkbeans)}
      columns={columns}
      filter={filterFactory()}
      pagination={paginationFactory(Lib.bootstraptableProps)}
      selectRow={selectRow}
    />
  );
}

renderModals = () => {
  return (
  <React.Fragment>
    <Modal isOpen={this.state.modalTorles} toggle={this.toggleTorles} className={this.props.className} backdrop="static">
      <ModalHeader>Törlés</ModalHeader>
      <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
      <ModalFooter>
        <ProgressButton loading={this.state.deleteButtonLoading} className="btn-cursor-pointer" color="primary" onClick={() => this.deleteCikk(this._currentDeleteObj)}>OK</ProgressButton>
        <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleTorles}>Mégsem</Button>
      </ModalFooter>
    </Modal>

    <Modal isOpen={this.state.modalAccept} toggle={this.toggleAccept} className={this.props.className} backdrop="static">
      <ModalHeader>Mentés és véglegesítés</ModalHeader>
      <ModalBody>„Mentés és véglegesítés” után az adott tétel nem módosítható, törölhető, csak stornózható! Valóban elfogadja rögzített adatok mentését?</ModalBody>
      <ModalFooter>
        <ProgressButton loading={this.state.mentesLoadingButton} className="btn-cursor-pointer" color="primary" id="save-and-close" onClick={() => this.save(null, this._currentAcceptObj)}>OK</ProgressButton>
        <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleAccept}>Mégsem</Button>
      </ModalFooter>
    </Modal>

    <Modal isOpen={this.state.modalRendelesCikk} toggle={this.toggleRendelesCikk} className={this.props.className} backdrop="static" size="lg">
      <ModalHeader>Cikkek választása</ModalHeader>
      <ModalBody>
        {this.renderRendelesCikkTable()}
      </ModalBody>
      <ModalFooter>
        <Button className="btn-cursor-pointer" type="button" color="primary" onClick={this.handleRendelesCikkSubmit}>Kiválasztás</Button>
        <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleRendelesCikk}>Mégsem</Button>
      </ModalFooter>
    </Modal>

    <CikkSelect
      isOpen={this.state.modalCikk}
      toggle={this.toggleCikk}
      add={this.addCikk}
      ref={this.refCikkSelect}
      cikkek={this.state.cikkek}
      editmode={this.state.editmode}
      editobj={this.state.editobj}
      edit={this.editCikk}
      mozgasTipus={this.state.formMozgasTipus}
      mozgasDatum={this.state.formMozgasDatum}
      penznem={this.state.formPenznem}
      raktarId={this.state.formRaktar?.id}
      price
      globals={this.props.globals}
      visszaru={this.isVisszaruMozgTipus()}
      cikkekVisszaru={this.state.formCikkVisszList}
    />

    {/* Partner felvitel modal */}
    <Modal isOpen={this.state.modalPartnerFelvitel} toggle={this.togglePartnerFelvitel} className={this.props.className} backdrop="static" size="lg" >
      <RFForm
        modal
        onSubmit={this.addPartner}
        title="Partner felvétel"
        footer={
          <>
            <ProgressButton loading={this.state.addButtonLoading} color="primary">Mentés</ProgressButton>
            <Button type="button" color="secondary" onClick={this.togglePartnerFelvitel}>Vissza</Button>
          </>
        }
      >
        {this.renderPartnerInputFields()}
      </RFForm>
    </Modal>
  </React.Fragment>
  );
}

render() {
  return (
    <div>
      <RFForm onSubmit={this.save}>
        <div className="row" style={STYLE_ROW}>
          <div className="col-md-4">
            <SelectField
              variant='async'
              label='Mozgástípus:'
              name="formMozgastipus"
              id="formMozgastipus"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => this.setState({ formMozgasTipus: v, formCikkVisszList: [] })}
              loadOptions={_.debounce(this.loadMozgasTipusOptions, 1000)}
              getOptionLabel={option => option.name}
              getOptionValue={option => option.id}
              value={this.state.formMozgasTipus}
              isDisabled={!!this.state.bevetel.id}
              defaultOptions
              isClearable
            />
          </div>
          {this.isVisszaruMozgTipus() && <div className='col-md-4'>
              <SelectField
                variant='async'
                label='Előzmény bizonylatszám:'
                name="formElozmenyKeszlet"
                id="formElozmenyKeszlet"
                placeholder="Kezdj el gépelni..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                onChange={this.handleVisszaruChange}
                loadOptions={_.debounce(this.loadVisszaruCsokkenes, 1000)}
                getOptionLabel={option => option.bizonylatszam}
                getOptionValue={option => option.id}
                value={this.state.formElozmenyKeszlet}
                isClearable
                required
              />
            </div>}
        </div>
          {this.state.formMozgasTipus && this.renderForm()}
          {this.state.formMozgasTipus && this.renderCikkTable()}
          {this.renderButtons()}
        </RFForm>
        {this.renderModals()}
      </div>
    );
  }
  }

export default BevetelezesForm;
